module.exports = __webpack_public_path__ + "static/media/home_background.f837b9f1.jpeg";